import { render, staticRenderFns } from "./InvestQuantityCard.vue?vue&type=template&id=6955d7f6&scoped=true"
import script from "./InvestQuantityCard.vue?vue&type=script&lang=js"
export * from "./InvestQuantityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6955d7f6",
  null
  
)

export default component.exports